import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CreditModel } from 'common/models/page-models/credits/credit-data-model';
import { CreditListingModel } from 'common/models/page-models/credits/credit-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CreditGridWidgetService } from 'common/widget/credit/credit-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class CreditGridResolver extends GridResolver<CreditModel, CreditListingModel> {
    constructor(
        protected fs: CreditGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}